<template>
    <div class="cw-content">
        <form class="needs-validation" novalidate>
            <h1>{{$t('seb-title')}}</h1>

            <h2>{{$t('Step 1 of 5: Voter declaration and oath')}}</h2>

            <fieldset class="mt-4">
                <legend class="h6">{{$t('To be eligible to vote by Sealed Envelope Ballot (SEB), all of the following must apply:')}}</legend>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="declaration1" value="Yes" required v-model="eligible_to_vote">
                    <label class="custom-control-label font-weight-normal" for="declaration1">{{$t('I am an eligible voter in this election but am unable to attend the voting place in person on election day or at advance voting opportunities for one of the following reasons:')}}</label>
                    <ul class="mb-0">
                        <li>{{$t('I am unable to go in person to a voting station due to a disability; or')}}</li>
                        <li>{{$t('I am providing care to a person who is unable to leave their home; or')}}</li>
                        <li>
                            {{$t('I expect that on Election Day and the day or days of Advance Voting, I will be:')}}
                            <ol type="A">
                                <li>{{$t('absent from my local authority, or')}}</li>
                                <li>{{$t('at a location so significantly distant from the location I am eligible to vote at that it is not reasonably possible to vote at that location.')}}</li>
                            </ol>
                        </li>

                    </ul>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="declaration2" required value="Yes" v-model="have_not_vote">
                    <label class="custom-control-label font-weight-normal" for="declaration2">{{$t('I have not otherwise already voted in this election.')}}</label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="declaration3" required value="Yes" v-model="only_vote_by_seb">
                    <label class="custom-control-label font-weight-normal" for="declaration3">{{$t('I understand that upon receiving the Sealed Envelope Ballot package, I may only cast my ballot using this method of voting.')}}</label>
                </div>
                <div class="invalid-feedback" v-if="!valid_register">{{$t('mandatory_requirement')}}</div>
            </fieldset>

            <div class="row no-gutters">
                <div class="col">
                    <button class="btn btn-secondary mt-4 float-right" @click="next_step">{{$t('next')}}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<style scoped>
    .invalid {
        width: 100%;
        margin-top: .25rem;
        font-size: 1rem;
        color: #CE2334;
    }
</style>
<script>
    import $ from "jquery";

    export default{
        data() {
            return {
                eligible_to_vote: null,
                have_not_vote: null,
                only_vote_by_seb: null,
                page_type: null,
                voter: [],
            }
        },
        created: function () {
            this.voter = this.$store.getters.SEB_VOTER;

            this.page_type = this.$route.params.page_type;

            if (this.voter.length > 0) {
                let info = this.voter[0];

                this.eligible_to_vote = info.eligible_to_vote;
                this.have_not_vote = info.have_not_vote;
                this.only_vote_by_seb = info.only_vote_by_seb;
            }
        },
        methods: {
            next_step: function () {
                //bus.$emit('change-tab', tran('register_vote_two'));
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();

                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');
                    console.log($(".invalid-feedback"));
                    $(".invalid-feedback").removeClass("invalid-feedback").addClass("invalid");
                });
    
                if (validation === true) {
                    var voter = {
                        eligible_to_vote: this.eligible_to_vote,
                        have_not_vote: this.have_not_vote,
                        only_vote_by_seb: this.only_vote_by_seb,
                        page_type: this.page_type
                    };
                    //this.$store.commit('update_voter', voter);
                    this.$store.dispatch("SAVE_SEB_VOTER", voter);

                    this.$router.push({ name: "SealedEnvelopeBallotStep2", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id, registration_id: this.$route.params.registration_id } });
                }
            },
            cancel: function () {
                window.location = "default.stm";
            }
        },

        computed: {
            valid_eligible_to_vote: function () {
                console.log(this.eligible_to_vote);
                return (this.eligible_to_vote);
            },
            valid_have_note_vote: function () {
                return (this.have_not_vote);
            },
            valid_only_vote_by_seb: function () {
                return (this.only_vote_by_seb);
            },
            valid_register: function () {
                return (this.valid_eligible_to_vote && this.valid_have_note_vote && this.valid_only_vote_by_seb);
            },
            empty_form: function () {
                return (this.eligible_to_vote == null || this.have_not_vote == null || this.only_vote_by_seb == null);
            },
            disabled_button: function () {
                return (!this.valid_register);
            }
        },
    }
</script>